import { ConversationsService } from "./../../conversations/conversations.service";

import {
  Component,
  OnInit,
  Input,
  PACKAGE_ROOT_URL,
  TemplateRef,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Subscription } from "rxjs";
import * as _ from "underscore";
import { NgClass } from "@angular/common";
import { FilePreviewDirective } from "./file-preview.directive";

/**
 * Dashboard main page component. It's empty for now
 */
@Component({
    selector: "app-resources-item",
    templateUrl: "./resources-item.component.html",
    styleUrls: ["./resources.component.css"],
    imports: [FilePreviewDirective, NgClass]
})
export class ResourcesItemComponent implements OnInit {
  @Input() resource: any;
  @Input() link: boolean;

  constructor(private conversationsService: ConversationsService) {}

  ngOnInit(): void {}

  // refreshUrl(event): void {
  //   console.log('event', event);
  //   this.conversationsService.get_etag_by_url(this.resource.url).subscribe((res: any) => {
  //     this.etag = res.etag;
  //     this.resource.url = this.conversationsService.get_private_file(res.etag);
  //   })
  // }
}
